import { WebStore } from "interfaces";
import { createInitialSessionId } from "./session-id";
import { WebStoreSlice } from "./types";

export const initialState: WebStoreSlice = {
	store: {} as WebStore,
	sessionId: createInitialSessionId()
};
